import React from 'react';
import {useStyles} from "../ArticleDelivery.style";
import clsx from "clsx";
import ArticleDeliveryRowProperties from "./ArticleDeliveryRowProperties";
import ShowArticleDeliveryArticles from '../../../shared_components/Info/ShowArticleDeliveryArticles/ShowArticleDeliveryArticles';
import Checkbox from '../../../ui_components/Checkbox/Checkbox';
import ShowOrderNumber from '../../../shared_components/Info/ShowOrderNumber/ShowOrderNumber';
import ShowDate from '../../../shared_components/Info/ShowDate/ShowDate';
import ShowText from '../../../shared_components/Info/ShowText/ShowText';
import ShowOrderStatus from '../../../shared_components/Info/ShowOrderStatus/ShowOrderStatus';
import ProductOrderStatus from '../../../entities/productOrder/ProductOrderStatus';
import UpdateDeliveryOrderStatusButton from '../../../shared_components/Buttons/UpdateDeliveryOrderStatusButton/UpdateDeliveryOrderStatusButton';
import ProductOrderTimelineButton from '../../../shared_components/Buttons/ProductOrderTimelineButton/ProductOrderTimelineButton';
import { motion } from 'framer-motion';
import AllowAccess from '../../../shared_components/Access/AllowAccess/AllowAccess';
import CommentsButton from '../../../shared_components/Buttons/CommentsButton/CommentsButton';
import ButtonSize from '../../../ui_components/Button/ButtonSize';
import ButtonType from '../../../ui_components/Button/ButtonType';
import ObservationsButton from '../../../shared_components/Buttons/ObservationsButton/ObservationsButton';
import RemoveArticleDeliveryButton from '../../../shared_components/Buttons/RemoveArticleDeliveryButton/RemoveArticleDeliveryButton';
import ShowPhoneNumber from '../../../shared_components/Info/ShowPhoneNumber/ShowPhoneNumber';
import Access from '../../../shared_components/Access/AllowAccess/Access';
import ChooseDeliveryFlowLink from '../../../shared_components/Info/ChooseDeliveryFlowLink/ChooseDeliveryFlowLink';


const ArticleDeliveryRowSmall: React.FC<ArticleDeliveryRowProperties> = ({
                                                                                    articleDeliveryOrder,
                                                                                    onArticleDeliveryOrderClick,
                                                                                    onDeliveryFlowSelect,
                                                                                    onArticleDeliveryOrderSelect,
                                                                                    onUpdate
                                                                                }) => {

    const classes = useStyles();

    const onArticleDeliverySelect = () => {
        onArticleDeliveryOrderSelect(articleDeliveryOrder.id);
    }

    const onRowArticleRemittanceClick = () => {
        onArticleDeliveryOrderClick(articleDeliveryOrder.id);
    }

    return (
        <div className={clsx(classes.article_info_container_small)}>
            <div className={classes.first_row_small}>
                <div>
                    <div className={classes.order_number_container}>
                        <Checkbox text={''} onChange={onArticleDeliverySelect}/>
                        <ShowOrderNumber orderNumber={articleDeliveryOrder.orderNumber}/>
                    </div>
                    <ShowDate label={'Fecha'} timestamp={articleDeliveryOrder.createdAt} className={classes.margin_top_4}/>
                </div>
                <ShowArticleDeliveryArticles valueToPay={articleDeliveryOrder.totalToPay} articles={articleDeliveryOrder.articles}/>
            </div>
            <div className={classes.second_row_small}>
                <ShowText text={articleDeliveryOrder.clientName} title={'Remitente'}/>
                <div>
                    <ShowText text={articleDeliveryOrder.contactName} title={'Destinatario'}/>
                    {articleDeliveryOrder.contactPhone &&
                        <ShowPhoneNumber value={articleDeliveryOrder.contactPhone} showFlag={false}/>}
                </div>
            </div>
            <div><small>Entrega</small>
                <div><ShowText text={articleDeliveryOrder.address}
                                title={articleDeliveryOrder.geo ? 
                                articleDeliveryOrder.geo.name + '. ' + articleDeliveryOrder.geo.parentInfo :
                                ''}/>
                </div>
            </div>
            <div className={classes.second_row_small}>
                <div>
                    <AllowAccess any={[Access.DISPLAY_DELIVERY_PERSON_IN_ORDERS,Access.SET_MONEY_DELIVERY_DELIVERY_PERSON]}>
                        <div className={classes.delivery_flow_container}>
                            <ChooseDeliveryFlowLink
                                articleDeliveryId={articleDeliveryOrder.id}
                                articleDeliveryStatus={articleDeliveryOrder.status}
                                deliveryFlow={articleDeliveryOrder.deliveryFlow}
                                warehouseStep={articleDeliveryOrder.warehouseStep}
                                orderByGeosIdProximity={[articleDeliveryOrder.geo.id]}
                                haveDeliveryPersonSelected={articleDeliveryOrder.deliveryPersonId != null}
                                onClick={onRowArticleRemittanceClick}
                                onSelect={onDeliveryFlowSelect}
                                onClose={onUpdate}
                                readOnly={
                                    articleDeliveryOrder.status === 'DELIVERED' ||
                                    articleDeliveryOrder.status === 'CANCELED' ||
                                    articleDeliveryOrder.status === 'NOT_DELIVERED' ||
                                    articleDeliveryOrder.status === 'PROCESSING'
                                }
                            />
                        </div>
                </AllowAccess>
                </div>
                <div>
                    <ShowText text={articleDeliveryOrder.agencyName} title={'Agencia'}/>
                    <ShowText text={articleDeliveryOrder.userName} title={'Vendedor'} className={classes.margin_top_8}/>
                </div>
                <div className={classes.status_container}>
                    <ShowOrderStatus status={articleDeliveryOrder.status}/>
                    {articleDeliveryOrder.status !== ProductOrderStatus.DELIVERED &&
                        articleDeliveryOrder.status !== ProductOrderStatus.CANCELED &&
                        <UpdateDeliveryOrderStatusButton onSave={onUpdate} productOrderId={articleDeliveryOrder.id}/>}
                    {articleDeliveryOrder.status === ProductOrderStatus.DELIVERED &&
                        <ProductOrderTimelineButton
                            detailsLink
                            productOrderId={articleDeliveryOrder.id}
                        />}
                </div>
            </div>
            <div className={classes.menu_container_small}>
                <motion.div animate={{scale: [0, 1]}} transition={{delay: 0.2, duration: 0.2}}>
                    <ProductOrderTimelineButton
                        size={ButtonSize.SMALL}
                        productOrderId={articleDeliveryOrder.id}
                        showText
                        type={ButtonType.SECONDARY}
                    />
                </motion.div>
            </div>
            <div className={clsx(classes.menu_container_small,classes.margin_top_n10px)}>
                <motion.div animate={{scale: [0, 1]}} transition={{delay: 0.2, duration: 0.2}}>
                    <ObservationsButton
                        size={ButtonSize.SMALL}
                        deliveryOrderId={articleDeliveryOrder.id}
                        deliveryOrderNumber={articleDeliveryOrder.orderNumber}
                        deliveryOrderObservations={articleDeliveryOrder.observations}
                        showText
                        type={ButtonType.SECONDARY}
                    />
                </motion.div>
                <AllowAccess isRootAgency={true}>
                    <motion.div animate={{scale: [0, 1]}} transition={{delay: 0.2, duration: 0.2}}>
                        <CommentsButton
                            size={ButtonSize.SMALL}
                            deliveryOrderId={articleDeliveryOrder.id}
                            deliveryOrderNumber={articleDeliveryOrder.orderNumber}
                            showText
                            type={ButtonType.SECONDARY}
                        />
                    </motion.div>
                </AllowAccess>
            </div>
            <div className={clsx(classes.menu_container_small,classes.margin_top_n10px)}>
                <motion.div animate={{scale: [0, 1]}} transition={{delay: 0.2, duration: 0.2}}>
                    <RemoveArticleDeliveryButton
                        size={ButtonSize.SMALL}
                        onSave={onUpdate}
                        articleDeliveryOrderId={articleDeliveryOrder.id}
                        showText
                        type={ButtonType.SECONDARY}
                    />
                </motion.div>
            </div>
        </div>
    )
}

export default ArticleDeliveryRowSmall;
